import SpadeSuit from '@/assets/icons/spade-suit.svg?react';
import { cn } from '@/shared/utils/cn';

export type AceBadgeProps = {
  className?: string;
};

export function AceBadge({ className }: AceBadgeProps) {
  return <SpadeSuit className={cn('inline-block size-3', className)} />;
}
